import React, { useState, useEffect } from "react";
import { Controller } from "react-hook-form";
import { FormGroup } from "reactstrap";
import { RadioSelectField } from "../../CommonElements";
import CheckboxSelectField from "../../CommonElements/Form/CheckSelectField";

const RiwayatPenyakit = ({ control, watch, setValue, preview=false }) => {
  const penyakit = watch("penyakit");
  const penyakitDetail = watch("penyakit_detail") || "";
  const alergiMakanan = watch("alergi_makanan") || [];
  const isSubmitted = watch("submit") === true | preview;
  
  const [textInputs, setTextInputs] = useState({
    "Seafood": watch("alergi_seafood") || "",
    "Yang lain:": watch("alergi_makanan_lainnya") || ""
  });
  
  useEffect(() => {
    setTextInputs({
      "Seafood": watch("alergi_seafood") || "",
      "Yang lain:": watch("alergi_makanan_lainnya") || ""
    });
  }, [watch("alergi_seafood"), watch("alergi_makanan_lainnya")]);
  
  const optionsPenyakit = [
    {
      id: 1,
      name: "Ya",
      value: "Ya",
    },
    {
      id: 2,
      name: "Tidak",
      value: "Tidak",
    },
  ];
  
  const optionsPedas = [
    {
      id: 1,
      name: "Ya",
      value: "Ya",
    },
    {
      id: 2,
      name: "Tidak",
      value: "Tidak",
    },
  ];
  
  const optionsAlergi = [
    {
      id: 1,
      name: "Tidak Memiliki Alergi",
      value: "Tidak Memiliki Alergi"
    },
    {
      id: 2,
      name: "Ayam",
      value: "Ayam"
    },
    {
      id: 3,
      name: "Sapi",
      value: "Sapi"
    },
    {
      id: 4,
      name: "Seafood",
      value: "Seafood"
    },
    {
      id: 5,
      name: "Yang lain:",
      value: "Yang lain:"
    }
  ];
  
  const withTextInputs = {
    "Seafood": true,
    "Yang lain:": true
  };
  
  const textInputPlaceholders = {
    "Seafood": "Mohon sebutkan (contoh: cumi, udang, gurita)",
    "Yang lain:": "Alergi makanan lainnya"
  };
  
  const handleTextInputChange = (optionValue, textValue) => {
    // Don't update if form is submitted/disabled
    if (isSubmitted) return;
    
    setTextInputs({
      ...textInputs,
      [optionValue]: textValue
    });
    
    if (optionValue === "Seafood") {
      setValue("alergi_seafood", textValue);
    } else if (optionValue === "Yang lain:") {
      setValue("alergi_makanan_lainnya", textValue);
    }
  };

  return (
    <div>
      <div className="purple-header mb-4 bg-primary">
        <h3 className="text-white p-3">Riwayat Penyakit</h3>
      </div>

      <div className="form-section-content">
        <FormGroup style={{border: "1px solid #ccc", padding: "20px", borderRadius: "5px"}}>
          <Controller
            name="penyakit"
            control={control}
            rules={{ required: "Harap pilih salah satu" }}
            render={({field, fieldState}) => (
              <RadioSelectField
                label="Apakah Bapak/Ibu memiliki penyakit tertentu yang perlu diketahui panitia?"
                options={optionsPenyakit}
                fieldState={fieldState}
                isRequired={true}
                withTextInput={true}
                textInputOption="Ya"
                textInputName="penyakit_detail"
                textInputValue={penyakitDetail}
                textInputPlaceholder="Mohon sebutkan penyakit anda"
                onTextInputChange={(e) => {
                  if (!isSubmitted) {
                    setValue("penyakit_detail", e.target.value);
                  }
                }}
                {...field}
                disabled={isSubmitted}
              />
            )}
          />
        </FormGroup>

        <FormGroup style={{border: "1px solid #ccc", padding: "20px", borderRadius: "5px"}}>
          <Controller
            name="alergi_makanan"
            control={control}
            rules={{ required: "Harap pilih minimal satu opsi" }}
            render={({field, fieldState}) => (
              <CheckboxSelectField
                label="Apakah Bapak/Ibu memiliki alergi terhadap makanan di bawah?"
                options={optionsAlergi}
                fieldState={fieldState}
                isRequired={true}
                withTextInputs={withTextInputs}
                textInputValues={textInputs}
                textInputPlaceholders={textInputPlaceholders}
                onTextInputChange={handleTextInputChange}
                {...field}
                disabled={isSubmitted} // Pass disabled prop explicitly
              />
            )}
          />
        </FormGroup>

        <FormGroup style={{border: "1px solid #ccc", padding: "20px", borderRadius: "5px"}}>
          <Controller
            name="makan_pedas"
            control={control}
            rules={{ required: "Harap pilih salah satu" }}
            render={({field, fieldState}) => (
              <RadioSelectField
                label="Apakah anda bisa makan makanan pedas?"
                options={optionsPedas}
                fieldState={fieldState}
                isRequired={true}
                {...field}
                disabled={isSubmitted}
              />
            )}
          />
        </FormGroup>
      </div>
    </div>
  );
};

export default RiwayatPenyakit;